import { mainApi } from '../index';
import type {
    ExperimentAssignmentResponse,
    GetExperimentCommunityStatsResponse,
    GetExperimentMetadataResponse,
    GetExperimentsCommunitiesResponse,
} from './types';

/*
 * Assign experiment to user
 */
export async function assignExperiment(name: string, variant: 0 | 1): Promise<ExperimentAssignmentResponse> {
    const response = await mainApi.put<ExperimentAssignmentResponse>('v1/experiments/variant-assignment', {
        name,
        variant,
    });
    return response.data;
}

/*
 * Join experiment communities
 */
export async function getExperimentsCommunities(): Promise<GetExperimentsCommunitiesResponse> {
    const response = await mainApi.post<GetExperimentsCommunitiesResponse>('v1/users/experiments/join_communities');
    return response.data;
}

/*
 * Get experiment community stats
 */
export async function getExperimentCommunityStats(): Promise<GetExperimentCommunityStatsResponse> {
    const response = await mainApi.get<GetExperimentCommunityStatsResponse>('v1/users/experiments/community_stats');
    return response.data;
}

/*
 * Get experiment metadata
 */
export async function getExperimentMetadata(): Promise<GetExperimentMetadataResponse> {
    const response = await mainApi.get<GetExperimentMetadataResponse>('v1/users/experiments/metadata');
    return response.data;
}
